module.exports = __webpack_public_path__ + "media/images/foot_btm-a691c945182ed8ce3de645c8fa41db5e.gif";